export default __webpack_public_path__ + "static/media/yael-pedhatzur.ceca76fd.png";